import React from 'react';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import WarningIcon from '@mui/icons-material/WarningAmberOutlined';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import { Typography, Box, Icon } from '@mui/material';
import { PayNowErrorSeverity } from '@acorn-portal/shared/src/hooks/use-paynow-details-token';

interface PayNowTokenisedLinkErrorProps {
	message: string;
	severity: PayNowErrorSeverity;
	children?: React.ReactNode;
}

const iconMap = {
	[PayNowErrorSeverity.INFO]: InfoIcon,
	[PayNowErrorSeverity.WARNING]: WarningIcon,
	[PayNowErrorSeverity.ERROR]: ErrorIcon,
};

const PayNowTokenisedLinkError: React.FC<PayNowTokenisedLinkErrorProps> = ({ message, severity, children }) => {
	const IconComponent = iconMap[severity];

	const boxStyles = {
		display: 'flex',
		flexDirection: 'column' as const,
		alignItems: 'center',
		justifyContent: 'center',
		p: { lg: 4, xs: 0 },
		m: 2,
	};

	return (
		<Box sx={boxStyles}>
			<Icon sx={{ fontSize: 110 }}>
				<IconComponent color={severity} sx={{ fontSize: 110 }} />
			</Icon>
			<Typography variant='h5' sx={{ mt: 2, textAlign: 'center' }}>
				{message}
			</Typography>
			{children && <Box sx={{ mt: 2 }}>{children}</Box>}
		</Box>
	);
};

export default PayNowTokenisedLinkError;
